import { cn, Span } from '@scatterlab/zeta-core';
import {
  ComponentPropsWithoutRef,
  ComponentRef,
  createElement,
  ElementType,
  memo,
  RefAttributes,
} from 'react';

import { CheckBadgeIcon } from '../icons';

export type CreatorTagProps<Component extends ElementType = typeof Span> =
  ComponentPropsWithoutRef<Component> &
    RefAttributes<ComponentRef<Component>> & {
      component?: Component;
      label: string;
      noSymbol?: boolean;
      verified?: boolean;
    };

const CreatorTag = <Component extends ElementType = typeof Span>({
  label,
  className,
  component,
  noSymbol,
  verified,
  ...props
}: CreatorTagProps<Component>) =>
  createElement(
    component ?? Span,
    {
      title: label,
      ...props,
      className: cn(
        'body12 flex max-w-full flex-row items-center gap-0.5 truncate rounded-[6px] border border-white/[8%] bg-black/60 px-1 py-[3px] align-middle font-medium text-white/50 backdrop-blur-[8px]',
        className,
      ),
    },
    verified && <CheckBadgeIcon className="size-3 text-white" />,
    `${noSymbol ? '' : '@'}${label}`,
  );

export default memo(CreatorTag) as typeof CreatorTag;
